import { render, staticRenderFns } from "./SelectAnios.vue?vue&type=template&id=60e14fb9&"
import script from "./SelectAnios.vue?vue&type=script&lang=js&"
export * from "./SelectAnios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports